import React from 'react'
import ReactGA from 'react-ga'
import RestoreScoll from 'components/RestoreScroll'
import PropTypes from 'prop-types'
import SellerContact from 'components/SellerContact'
import { connect } from 'react-redux'
import { Icon } from '@yapay/design-system'
import useDecrementCounter from 'hooks/useDecrementCounter'

export const CardWaitingChallenge = props => {
  const { transaction } = props.order
  const challengeUrl = props.challengeUrl
  const [counter, stopCounter] = useDecrementCounter(2)
  const popupRef = React.useRef(null)
  const faqUrl =
    'https://atendimento-pagamentos.vindi.com.br/hc/pt-br/articles/38050657009819-Autentica%C3%A7%C3%A3o-3DS-no-Link-de-Pagamento-Entenda-como-funciona'

  React.useEffect(() => {
    if (counter === 0) {
      stopCounter()

      const width = 540
      const height = 360
      const left = window.screenX + (window.outerWidth - width) / 2
      const top = window.screenY + (window.outerHeight - height) / 2
      popupRef.current = window.open(
        challengeUrl,
        'Vindi',
        `width=${width},height=${height},left=${left},top=${top},resizable=no,scrollbars=no,status=no,location=no,toolbar=no`,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter])

  React.useEffect(() => {
    const handleUnload = () => {
      if (popupRef.current && !popupRef.current.closed) {
        popupRef.current.close()
      }
    }

    window.addEventListener('beforeunload', handleUnload)
    return () => {
      window.removeEventListener('beforeunload', handleUnload)
      if (popupRef.current && !popupRef.current.closed) {
        popupRef.current.close()
      }
    }
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => () => stopCounter(), [])

  ReactGA.event({
    category: 'Card Payment',
    action: 'Waiting Challenge',
  })

  return (
    <div>
      <RestoreScoll />
      <h2>Pagamento em andamento! Transação nº {transaction}</h2>
      <br />

      <div className="flex">
        <div className="mr-4">
          <Icon
            icon="transfer"
            width="67"
            height="67"
            className="fill-current text-gray-600"
          />
        </div>
        <p className="m-0">
          Para sua segurança, esta transação será autenticada.
          <br />
          <br />
          Para finalizar o pagamento, acesse o PopUp que irá abrir sob esta
          página e siga as instruções do banco emissor do seu cartão.
          <br />
          <br />
          <span style={{ color: '#007db4' }}>
            Caso o PopUp não abra automaticamente,
          </span>{' '}
          <a href={challengeUrl} target="_blank" rel="noreferrer">
            <b>acesse aqui.</b>
          </a>
          <br />
          <br />
          Se o problema persistir, acesse nossa{' '}
          <a
            href={faqUrl}
            style={{ textDecoration: 'none', color: 'inherit' }}
            target="_blank"
            rel="noreferrer"
          >
            <b>FAQ.</b>
          </a>
        </p>
      </div>

      <SellerContact />

      <div className="flex items-center">
        <div className="mr-4">
          <Icon
            icon="mail"
            width="67"
            height="67"
            className="fill-current text-gray-600"
          />
        </div>
        <p className="m-0">
          Após autenticado, você será informado por e-mail sobre o andamento do
          pedido.
        </p>
      </div>
    </div>
  )
}

CardWaitingChallenge.propTypes = {
  seller: PropTypes.object,
  order: PropTypes.object,
  challengeUrl: PropTypes.string,
}

const mapStateToProps = state => state

export default connect(mapStateToProps)(CardWaitingChallenge)
